globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Plugins = appCustomerSpace.Plugins || {};

appCustomerSpace.Plugins.initPlugins = function ($html) {

  $html = $html || $('body');

  initDateRangePickers();
  appCustomerSpace.CKEditor.init($html);
  appCustomerSpace.HighChartsChart.init($html);
  appCustomerSpace.CalendlyIframe.init($html);
  appCustomerSpace.ChartsFrenquency.init($html);

  $html.find('.component-video').each(function () {
    new appCustomerSpace.ComponentVideo($html.find('.component-video'));
  });

  $html.find('.tokenfield').tokenfield();
  $html.find("[data-popup='popover']").popover();
  $html.find("input.styled").uniform({
    radioClass: 'choice'
  });

  if ($(window).width() < 768) {
    $html.find('[data-popup=tooltip]').each(function () {
      $(this).tooltip('disable');
    });
  }

  var clipboards = new Clipboard('.clipboard');
  clipboards.on('success', function (e) {
    var $e = $(e.trigger),
      $icon = $e.find("i");

    $e.attr('data-original-title', 'Copié !').tooltip('show').blur();

    if (!$icon.length) return;

    var classes = $icon.attr("class").split(" ");

    for (var i = 0; i < classes.length; i++) {
      if (classes[i].startsWith('fa-')) {
        $icon.removeClass(classes[i]);
        $icon.addClass("fa-check");
      }
    }

  }).on('error', function (e) {
    $(e.trigger).attr('data-original-title', 'Erreur de copie...').tooltip('show').blur();
  });

  autosize($html.find('.autosize'));
  $html.find('.tags-input').tagsinput();

  $html.find(".file-styled").uniform({
    fileButtonClass: 'action btn btn-default'
  });

  ValueSwitcher.init();
  EmojiPicker.init();
}
